document.addEventListener("DOMContentLoaded", function(){
  document.querySelectorAll('.video-box').forEach(box => {
    const id = box.dataset.blockId;
    const previewVideo = document.getElementById('previewVideo-' + id);
    const popup = document.getElementById('videoPopup-' + id);
    const mainVideo = document.getElementById('mainVideo-' + id);
    const closeBtn = document.getElementById('closePopup-' + id);

    previewVideo.addEventListener('timeupdate', () => {
      if (previewVideo.currentTime >= 47) {
        previewVideo.currentTime = 0;
        previewVideo.play();
      }
    });

    previewVideo.addEventListener('click', () => {
      popup.classList.add('active');
      mainVideo.currentTime = 0;
      mainVideo.play();
      document.body.classList.add('show-video-popup');
    });

    closeBtn.addEventListener('click', () => {
      popup.classList.remove('active');
      mainVideo.pause();
      document.body.classList.remove('show-video-popup');
    });
  });
});